import { EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { visitHistoryTranslationKeys } from '../../translations';

import {
   usePatientConsentColumnsConfiguration,
   usePatientConsentsDataConfiguration,
} from './PatientConsentsTable.hooks';

type PatientConsentsTableProps = {
   readonly visitId: number;
   readonly patientId: number;
};

export const PatientConsentsTable = (props: PatientConsentsTableProps): JSX.Element => {
   const dataConfiguration = usePatientConsentsDataConfiguration(props.visitId, props.patientId);
   const columns = usePatientConsentColumnsConfiguration({ refetchData: dataConfiguration.refetch });

   return (
      <Table
         testId={'patientConsents'}
         dataConfiguration={dataConfiguration}
         columns={columns}
         keyExtractor={'id'}
         pageSize={1000}
         placeholder={
            <EmptyStatePlaceholder
               testId={'patientConsents'}
               heading={visitHistoryTranslationKeys.patientConsentsTable.noPatientConsents}
               subheading={visitHistoryTranslationKeys.patientConsentsTable.noPatientConsentsWereIssued}
            />
         }
      />
   );
};
